"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PercentageTooltipText = void 0;
const react_1 = __importStar(require("react"));
const components_1 = require("@veeam/components");
require("@veeam/components/lib/Tooltip/types");
const trimmedTextRenderer_1 = require("@veeam/components/lib/Grid/cellRenderers/trimmedTextRenderer");
const helpers_1 = require("@veeam/components/lib/Grid/cellRenderers/helpers");
const helpers_2 = require("../../../../../../helpers");
const constants_1 = require("../../../../../../constants");
const core_1 = require("../../../../../../core");
const PercentageTooltipText = (_a) => {
    var { value = 0, delta = 0 } = _a, props = __rest(_a, ["value", "delta"]);
    const { t } = core_1.useFeatureContext();
    const ref = react_1.useRef(null);
    const sign = value < 0 ? '-' : '+';
    return components_1.useTooltip({
        delayTimeout: 500,
        isActive: value !== 0,
        renderContent: () => (react_1.default.createElement(components_1.StackView, { direction: components_1.STACK_DIRECTION.column },
            react_1.default.createElement(components_1.Text, { weight: components_1.TEXT_WEIGHT.bold }, value < 0
                ? t('dashboard|topPolicies|grid|column|percentage|decrease')
                : t('dashboard|topPolicies|grid|column|percentage|increase')),
            react_1.default.createElement(helpers_1.TooltipText, { size: components_1.TEXT_SIZE.s }, `${sign}${helpers_2.getFormattedDuration({
                durationValue: Math.abs(delta),
                unit: 'milliseconds',
                emptyValue: '0sec',
            })}`))),
        render: (tooltipProps) => {
            return (react_1.default.createElement("div", Object.assign({}, tooltipProps, { ref: ref }), trimmedTextRenderer_1.trimmedTextRenderer(Object.assign(Object.assign({}, props), { cellData: value !== 0 ? `${sign}${Math.round(Math.abs(value))}%` : constants_1.EMPTY_TEXT.dash }))));
        },
    });
};
exports.PercentageTooltipText = PercentageTooltipText;
//# sourceMappingURL=PercentageTooltipText.js.map